"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.CertificationStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  justify-content: stretch;
  width: 100%;

  @media (min-width: ${constants_1.sizes.tablet}) {
    gap: 1.5em;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    gap: 3em;
  }

  >.certification-content {
    display: flex;
    gap: 1.5em;
    align-items: stretch;
    justify-content: stretch;
    margin-top: 1.6em;

    > table {
      width: 100%;
      padding-left: 0.8em;

      > thead {
        > tr {
          border-bottom: 0.0625em solid ${design_system_1.theme.colors.marine[50]};

          > th {
            width: 20%;
            margin-left: 0.8em;
            padding-left: 0.8em;
          }
        }
      }

      > tbody {
        > tr {
          height: 2.4em;

          &:nth-child(odd) {
            background-color: ${design_system_1.theme.colors.marine[5]};
          }

          .no-date {
            display: flex;
            padding-left: 30%;
          }

          td {
            vertical-align: middle;
            padding-left: 0.8em;

            button {
              :focus {
                span {
                  background-color: ${design_system_1.theme.colors.cyan[100]};
                }

                .close-icon {
                  width: 1.3em;
                  height: 1.3em;
                }
              }
            }
          }
        }
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 0.8em;
    }

    li {
      b {
        font-weight: bold;
      }
    }

    &.missing {
      color: ${design_system_1.theme.colors.marine[70]};
    }
  }

  .popup-tooltip {
    height: fit-content;
  }

  .popup-tooltip > .modal {
    height: fit-content;
  }

  .popup-tooltip > .modal > .content {
    display: flex;
    flex-direction: column;
    gap: 0.8em;
    overflow: auto;
    height: fit-content;

    @media (min-width: ${constants_1.sizes.tablet}) {
      width: 40em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      width: 25em !important;
    }

    .title-certificat {
      display: flex;
      flex-direction: column;
      width: 100%;

      .control {
        width: 75%;
      }
    }

    .certifier {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .date {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .control {
        width: 25%;
      }
    }

    .error-date {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      width: 100%;
      color: ${design_system_1.theme.colors.red[50]};
      font-size: medium;
    }

    .number-certificat {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .control {
        width: 25%;
      }
    }

    >.control-certification-form {
      display: flex;
      align-items: flex-end;

      >button {
        width: 50%;
      }
    }
  }

  >.certification-controls {
    display: flex;
    gap: 1em;
    width: 100%;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
      align-items: stretch;
      justify-content: flex-end;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
    }
  }
}
`;
//# sourceMappingURL=Certification.styled.js.map